import React from 'react'
import { DataTable } from '@paypalcorp/pp-react'

const CodeCell = (value) => {
  return <code>{value.value}</code>
}

const allRows = [
  {
    id: 'row1',
    cardNetwork: {
      value: 'Mastercard',
    },
    cardType: {
      value: 'Credit and debit cards',
    },
    issuingCountry: {
      value: (
        <span>
          <code>AT</code>, <code>AU</code>, <code>BE</code>, <code>BG</code>,{' '}
          <code>CA</code>, <code>CY</code>, <code>CZ</code>, <code>DE</code>,{' '}
          <code>DK</code>, <code>EE</code>, <code>ES</code>, <code>FI</code>,{' '}
          <code>FR</code>, <code>GR</code>, <code>HU</code>, <code>IE</code>,{' '}
          <code>IT</code>, <code>LI</code>, <code>LT</code>, <code>LU</code>,{' '}
          <code>LV</code>, <code>MT</code>, <code>NL</code>, <code>NO</code>,{' '}
          <code>PL</code>, <code>PT</code>, <code>RO</code>, <code>SE</code>,{' '}
          <code>SI</code>, <code>SK</code>, <code>UK</code>, <code>US</code>
        </span>
      ),
    },
    merchantCountry: {
      value: (
        <span>
          <code>AT</code>, <code>AU</code>, <code>BE</code>, <code>BG</code>,{' '}
          <code>CA</code>, <code>CN</code>, <code>CY</code>, <code>CZ</code>,{' '}
          <code>DE</code>, <code>DK</code>, <code>EE</code>, <code>ES</code>,{' '}
          <code>FI</code>, <code>FR</code>, <code>GR</code>, <code>HU</code>,{' '}
          <code>IE</code>, <code>IT</code>, <code>LI</code>, <code>LT</code>,{' '}
          <code>LU</code>, <code>LV</code>, <code>MT</code>, <code>NL</code>,{' '}
          <code>NO</code>, <code>PL</code>, <code>PT</code>, <code>RO</code>,{' '}
          <code>SE</code>, <code>SI</code>, <code>SK</code>, <code>UK</code>,{' '}
          <code>US</code>
        </span>
      ),
    },
  },
  {
    id: 'row2',
    cardNetwork: {
      value: 'Visa',
    },
    cardType: {
      value: 'Credit and debit cards',
    },
    issuingCountry: {
      value: (
        <span>
          <code>AT</code>, <code>AU</code>, <code>BE</code>, <code>BG</code>,{' '}
          <code>CH</code>, <code>CY</code>, <code>CZ</code>, <code>DE</code>,{' '}
          <code>DK</code>, <code>EE</code>, <code>ES</code>, <code>FI</code>,{' '}
          <code>FR</code>, <code>GR</code>, <code>HK</code>, <code>HU</code>,{' '}
          <code>IE</code>, <code>IT</code>, <code>LT</code>, <code>LU</code>,{' '}
          <code>LV</code>, <code>MT</code>, <code>NL</code>, <code>NO</code>,{' '}
          <code>PL</code>, <code>PT</code>, <code>RO</code>, <code>SE</code>,{' '}
          <code>SG</code>, <code>SI</code>, <code>SK</code>, <code>UK</code>,{' '}
          <code>US</code>
        </span>
      ),
    },
    merchantCountry: {
      value: (
        <span>
          <code>AT</code>, <code>AU</code>, <code>BE</code>, <code>BG</code>,{' '}
          <code>CA</code>, <code>CN</code>, <code>CY</code>, <code>CZ</code>,{' '}
          <code>DE</code>, <code>DK</code>, <code>EE</code>, <code>ES</code>,{' '}
          <code>FI</code>, <code>FR</code>, <code>GR</code>, <code>HU</code>,{' '}
          <code>IE</code>, <code>IT</code>, <code>LI</code>, <code>LT</code>,{' '}
          <code>LU</code>, <code>LV</code>, <code>MT</code>, <code>NL</code>,{' '}
          <code>NO</code>, <code>PL</code>, <code>PT</code>, <code>RO</code>,{' '}
          <code>SE</code>, <code>SI</code>, <code>SK</code>, <code>UK</code>,{' '}
          <code>US</code>
        </span>
      ),
    },
  },
]

const columns = {
  cardNetwork: {
    title: 'Card network',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  cardType: {
    title: 'Card type',
    mobile: {
      placement: 'b3',
    },
  },
  issuingCountry: {
    title: 'Issuing country',
    mobile: {
      placement: 'b3',
    },
  },
  merchantCountry: {
    title: 'Merchant country',
    mobile: {
      placement: 'b3',
    },
  },
}

const CountryTableRtau = () => {
  return (
    <>
      <p>
        The following table shows the card types and countries that real-time
        account updater supports.
      </p>
      <ul>
        <li>
          <strong>Issuing country:</strong> The country of the bank that issues
          the card.
        </li>
        <li>
          <strong>Merchant country:</strong> The country where the merchant
          receives the payment.
        </li>
      </ul>
      <DataTable
        description="Basic"
        rows={allRows}
        columns={columns}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
    </>
  )
}

export default CountryTableRtau
